export default __webpack_public_path__ + "static/media/logo.c45780d3.svg";